import MixpanelTracker from '../mixpanelTracker';
import Action from '../Model/action';

const mixpanelTracker = new MixpanelTracker();

export function onJoinSessionTracker(sessionData, eventName) {
  const properties = {
    Action: Action.CLICK,
    sessionData,
  };
  mixpanelTracker.setEventName(eventName);
  mixpanelTracker.setEventProperties(properties);
  mixpanelTracker.sendEvent();
}

export function onJoinSessionStatusTracker(sessionData, eventName) {
  const properties = {
    Action: Action.JOIN,
    sessionData,
  };
  mixpanelTracker.setEventName(eventName);
  mixpanelTracker.setEventProperties(properties);
  mixpanelTracker.sendEvent();
}
